// extracted by mini-css-extract-plugin
export default {"mainContainer":"TopToPage_mainContainer__R0EV7","icon":"TopToPage_icon__QQ1Qw"};